import LoaderComponent from '@components/atom/layout/loader';
import AppInfo from '@components/template/layout/appInfo/appInfo';
import PublisherInfo from '@components/template/app/publisher/publisherInfo';
import { RootState, AppDispatch } from '@reducers/index';
import { lazy, Suspense, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useQueryDummyHook } from '@utils/hook/useQueryHook';
import { gameProviderTypes } from '@configs/layout';
import { useQuery } from 'react-query';
import axios from 'axios';
import { fetchAppPublisherInfo } from '@reducers/appThunk';

const PublisherGrid = lazy(() => import('@components/template/app/publisher/publisherGrid'));

const PublisherProfile = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { selectedAppInfo } = useSelector((state: RootState) => state.LAYOUT);

  // 개발자(회사) 정보 요청처리
  useEffect(() => {
    if (selectedAppInfo) {
      dispatch(
        fetchAppPublisherInfo({
          devId:
            gameProviderTypes.GooglePlayStore === (selectedAppInfo?.provider_type ?? selectedAppInfo?.providerType)
              ? selectedAppInfo?.developer
              : selectedAppInfo?.developerId,
          provider_type: selectedAppInfo?.provider_type ?? selectedAppInfo?.providerType,
        })
      );
    }
  }, [selectedAppInfo]);

  return (
    <>
      <div className="app-info">
        <Suspense fallback={<LoaderComponent />}>
          <PublisherInfo />
        </Suspense>
      </div>
      <div className="table-api-wrap">
        <div className="table-api">
          <Suspense fallback={<LoaderComponent />}>{selectedAppInfo && <PublisherGrid />}</Suspense>
        </div>
      </div>
    </>
  );
};

export default PublisherProfile;
